/**
 * Date helpers — luôn dùng *local* timezone của browser, KHÔNG dùng
 * `new Date().toISOString()` cho "hôm nay" vì hàm đó trả về UTC.
 *
 * Ví dụ: lúc 06:30 sáng VN (UTC+7) → `new Date().toISOString().split('T')[0]`
 * trả về NGÀY HÔM QUA (UTC còn 23:30 hôm trước) → bộ lọc "hôm nay" trên
 * trang chấm công / log AI bị lệch 1 ngày → tưởng là log "sai theo thời gian".
 */

/** Trả về YYYY-MM-DD theo timezone của browser */
export function todayStr(d = new Date()) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/** YYYY-MM-DD `n` ngày trước/sau hôm nay (local TZ) */
export function offsetDays(n, base = new Date()) {
  const d = new Date(base);
  d.setDate(d.getDate() + n);
  return todayStr(d);
}

/** YYYY-MM-DD từ một Date/string bất kỳ, theo local TZ */
export function toLocalDateStr(input) {
  if (!input) return '';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return '';
  return todayStr(d);
}
